// extracted by mini-css-extract-plugin
export default {"formContainer":"GlobalOffer_formContainer__73uJg","calendar":"GlobalOffer_calendar__1xGHt"};